import './testOrderAttachmentsViewComponent.scss'
import React, {useEffect, useState} from 'react';
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import EditIcon from "@mui/icons-material/Edit";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {Grid} from "@mui/material";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../../store/reducers";
import commonService from "../../../../../shared/services/common.service";

interface TestOrderAttachmentsViewComponentProps {
    testOrderAttachments: any;
    onEditModeOpen: Function;
}

const TestOrderAttachmentsViewComponent = (props: TestOrderAttachmentsViewComponentProps) => {
        const {testOrderAttachments, onEditModeOpen} = props;
        const [testOrderAttachmentsList, setTestOrderAttachmentsList] = useState<any>(undefined);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        useEffect(() => {
            setTestOrderAttachmentsList(testOrderAttachments);
        }, [testOrderAttachments]);

        return (
            <div className="test-order-attachments-component details-tab-data-content">
                <>
                    {
                        ((testOrderAttachmentsList == null) || testOrderAttachmentsList.order || testOrderAttachmentsList.patient) ?
                            <div className="d-flex justify-content-space-between">
                                <div>
                                    {
                                        testOrderAttachmentsList?.order?.length > 0 && <>
                                            <div className="details-tab-data-header">
                                                <div className="view-and-edit-title">Order Attachments</div>
                                            </div>
                                            <div className='details-tab-data-body view-details-attachment-chip-list'>
                                                {testOrderAttachmentsList?.order.map((orderAttachment: any) => {
                                                    return (
                                                        <div key={orderAttachment.id} className={orderAttachment.title}>
                                                            <AttachmentViewDownloadComponent
                                                                attachment={orderAttachment}
                                                                attachmentTitle={orderAttachment.title}
                                                                showDeleteOption={false}
                                                                showDownloadOption={true}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </>
                                    }
                                    {
                                        testOrderAttachmentsList?.patient?.length > 0 && <>
                                            <div className="details-tab-data-header">
                                                <div className="view-and-edit-title">Patient Attachments</div>
                                            </div>
                                            <div className={'details-tab-data-body view-details-attachment-chip-list'}>
                                                {testOrderAttachmentsList?.patient.map((patientAttachment: any) => {
                                                    return (
                                                        <div key={patientAttachment.id}>
                                                            <AttachmentViewDownloadComponent
                                                                attachment={patientAttachment}
                                                                attachmentTitle={patientAttachment?.title}
                                                                showDeleteOption={false}
                                                                showDownloadOption={true}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </>
                                    }
                                </div>
                                <div>
                                    {
                                        commonService.checkAccess('TestOrder', 'testOrderEdit', currentUser?.userAccessModules) &&

                                        <ButtonComponent
                                            className={"white-space-nowrap"}
                                            type="button"
                                            color={"primary"}
                                            variant={"outlined"}
                                            startIcon={<EditIcon/>}
                                            fullWidth={true}
                                            handleClick={() => {
                                                onEditModeOpen()
                                            }}
                                        >
                                            Edit Details
                                        </ButtonComponent>
                                    }
                                </div>
                            </div>
                            :
                            <div className="no-attachments-wrapper">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <div className='no-attachments-header'>
                                            No attachments to show
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {
                                            commonService.checkAccess('TestOrder', 'testOrderEdit', currentUser?.userAccessModules) &&
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                variant={"outlined"}
                                                fullWidth={true}
                                                handleClick={() => {
                                                    onEditModeOpen()
                                                }}
                                            >
                                                Add Attachment
                                            </ButtonComponent>
                                        }
                                    </Grid>
                                </Grid>
                            </div>
                    }
                </>
            </div>
        )
    }
;
export default TestOrderAttachmentsViewComponent;
